import React, { Component } from 'react'
import * as Sentry from '@sentry/react'
import {
    isChunkLoadError,
    shouldRetryChunkLoad,
} from 'utils/chunkLoadRecovery'

class AppErrorBoundary extends Component {
    state = {
        error: null,
    }

    static getDerivedStateFromError(error) {
        return { error }
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error, {
            extra: {
                componentStack: errorInfo.componentStack,
            },
        })

        if (isChunkLoadError(error) && shouldRetryChunkLoad(error)) {
            window.location.reload()
        }
    }

    handleReload = () => {
        window.location.reload()
    }

    render() {
        const { error } = this.state

        if (!error) {
            return this.props.children
        }

        if (isChunkLoadError(error)) {
            return (
                <div
                    style={{
                        minHeight: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '24px',
                        textAlign: 'center',
                    }}
                >
                    <div>
                        <p>A newer version of the app is available.</p>
                        <button type="button" onClick={this.handleReload}>
                            Reload page
                        </button>
                    </div>
                </div>
            )
        }

        return <p>Something went wrong.</p>
    }
}

export default AppErrorBoundary
